import { GrupEkleGuncellePage } from './../grup-ekle-guncelle/grup-ekle-guncelle';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { BllOrtak } from './../../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../../../providers/ortak';

/**
 * Generated class for the GrupListesiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-grup-listesi',
  templateUrl: 'grup-listesi.html',
})
export class GrupListesiPage {
  aranan="";
  skip:number=0;
  take:number=100;
  GrupListesi=[];

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public modalCtrl:ModalController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.kayitAra(null);
  }
  kayitAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "CariGrupListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.GrupListesi = sonuc.SonucObject;
   
   
 
    })
  }
  
  grupkayitlari(e) {

    if (e.keyCode == 13) {
      this.kayitAra(e);
    }
  }
  yenikayit() {
    let modal = this.modalCtrl.create(GrupEkleGuncellePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  kayitduzenle(grup){
    let modal = this.modalCtrl.create(GrupEkleGuncellePage, { grupVw: grup });
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });
    modal.present();
   
  }
  GrupSil(grup) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("ID", grup.ID);

      this.bllOrtak.islem(formData, "GrupSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.kayitAra("");
     
    })
   
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/CariGrupIslemleri/grup-listesi/grup-listesi.ts